// extracted by mini-css-extract-plugin
export default {"title":"Dfifth_title__O0M10","desc":"Dfifth_desc__Z2dNY","text":"Dfifth_text__3tyNQ","small":"Dfifth_small__cDXBn","Dfifth":"Dfifth_Dfifth__q0oaS"};